import React, { Component } from 'react';
import { ScrollView } from 'react-native';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as createPostActions from 'modules/createPost/createPost.actions';
import { setCommunity } from 'modules/auth/auth.actions';
import { colors } from 'styles';
import TagSelection from './tagSelection.component';
import CommunitySelection from './communitySelection.component';

class Categories extends Component {
  static propTypes = {
    createPost: PropTypes.object,
    actions: PropTypes.object,
    tags: PropTypes.array,
    community: PropTypes.object,
  };

  constructor(props, context) {
    super(props, context);
    this.setTopic = this.setTopic.bind(this);
  }

  componentDidMount() {
    if (this.props.createPost.postCategory) {
      this.selectedTopic = this.props.createPost.postCategory;
    }
  }

  setTopic(topic) {
    if (this.props.createPost.postCategory === topic) {
      this.selectedTopic = null;
      this.props.actions.setPostCategory(null);
    } else {
      this.selectedTopic = topic;
      this.props.actions.setPostCategory(topic);
    }
    return null;
  }

  render() {
    const { createPost, actions, community } = this.props;
    let communityTags = [];
    if (community) {
      const activeCommunity = community.communities?.[community.active] || {};
      communityTags = activeCommunity?.topics || [];
    }

    return (
      <ScrollView style={{ backgroundColor: colors.white }}>
        <CommunitySelection actions={actions} community={community} />
        <TagSelection
          topic={null}
          communityTags={communityTags}
          actions={actions}
          createPost={createPost}
        />
      </ScrollView>
    );
  }
}

function mapStateToProps(state) {
  return {
    createPost: state.createPost,
    community: state.community,
    user: state.user,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...createPostActions,
        setCommunity,
      },
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Categories);
